"use strict";
exports.__esModule = true;
var angular = require("angular");
require('./history-modal.component.css');
var COMPONENT_NAME = 'smartorg.r6.acts.tableInputHistoryModal';
var HistoryModalComponent = /** @class */ (function () {
    function HistoryModalComponent() {
    }
    HistoryModalComponent.prototype.$onChanges = function () {
        if (this.records && this.records.length) {
            this.displayIndex = this.records.length - 1;
        }
        else {
            this.displayIndex = null;
        }
    };
    HistoryModalComponent.prototype.showHistory = function (indexMod) {
        this.displayIndex += indexMod;
    };
    return HistoryModalComponent;
}());
angular.module(COMPONENT_NAME, []).component('historyModal', {
    template: require('./history-modal.component.html'),
    bindings: {
        currentData: '<',
        records: '<'
    },
    controller: HistoryModalComponent
});
exports["default"] = COMPONENT_NAME;
//# sourceMappingURL=history-modal.component.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/gmf-commercial/history-modal/history-modal.component.js